import { Component } from 'react';

import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';
import {
  constants,
  namespace,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';
import observer from 'saddlebag-observer';

import withErrorBoundary from '../ErrorBoundary';

import AirportCard from './AirportCard';

import type { NearbyAirportsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/NearbyAirportsProps';

import STYLES from './NearbyAirports.module.scss';

class NearbyAirports extends Component<NearbyAirportsProps> {
  componentDidMount() {
    const {
      airports,
      trackingContext: { currency, deviceType, locale, market, pageType },
    } = this.props;
    observer.publish('grappler-track', {
      eventName: 'NearbyAirportsLoaded',
      fullSchemaName: 'nearby_airports.NearbyAirportsLoaded',
      message: {
        common_properties: {
          culture_settings: { country: market, currency, locale },
          page_type: constants[pageType],
          platform: deviceType || constants.UNSET_PLATFORM,
        },
        component_loaded: airports.length ? 'SUCCESS' : 'NO_CONTENT',
      },
      isMiniEvent: true,
      consentRequired: true,
      microsite: { name: namespace },
    });
  }

  render() {
    const {
      airports,
      destinationCityName,
      distanceUnit,
      isMobile,
      isReturn,
      strings,
      subTitle,
      title,
      trackingContext,
    } = this.props;
    if (!airports || airports.length === 0) {
      return <div id="nearby-airports" />;
    }

    return (
      <div className={STYLES.NearbyAirports} id="nearby-airports">
        <BpkSectionHeader title={title} description={subTitle} />
        <div className={STYLES.list}>
          {airports.map((airport, index) => (
            <AirportCard
              {...airport}
              key={airport.airportName}
              index={index}
              strings={strings}
              isMobile={isMobile}
              isReturn={isReturn}
              distanceUnit={distanceUnit}
              destinationName={destinationCityName}
              trackingContext={trackingContext}
            />
          ))}
        </div>
      </div>
    );
  }
}

const NearbyAirportsWithErrorBoundary = withErrorBoundary(
  NearbyAirports,
  'nearby-airports-component',
);
export default NearbyAirportsWithErrorBoundary;
